/**
 * BB Animate — global intersection observer for `[data-animate]` elements.
 *
 * Drop `data-animate` on any element. It starts hidden (opacity 0, offset 20px
 * down) via CSS, and when ~15% of it enters the viewport, a `.is-visible`
 * class is added → CSS fades + slides it into place. One-shot (unobserve
 * after reveal). Respects prefers-reduced-motion.
 */
(function () {
  if (window.__bbAnimateInit) return;
  window.__bbAnimateInit = true;

  function init() {
    var els = document.querySelectorAll('[data-animate]');
    if (!els.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px' });

    /* For elements already in/near the viewport at init, reveal them
       synchronously via rAF — don't rely on IO's first callback, which
       has been seen to skip silently in some Shopify preview contexts. */
    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    requestAnimationFrame(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < viewportH + 80 && r.bottom > -80) {
          el.classList.add('is-visible');
        } else {
          io.observe(el);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
